export default "__VITE_ASSET__f86557e0__"